import { mapGetters } from 'vuex'
import qs from 'qs'
import { SMART_SSH_FORM_DECORATORS } from '@Compute/constants'
import { disableDeleteAction } from '@/utils/common/tableActions'
import expectStatus from '@/constants/expectStatus'
import i18n from '@/locales'
import { typeClouds } from '@/utils/common/hypervisor'
import { commonUnabled, cloudEnabled, cloudUnabledTip, commonEnabled, validateRescueMode } from '../../vminstance/utils'
import { solWebConsole, jnlpConsole, getServerSshPort } from '../../../utils/webconsole'
import { hostServerActions } from '../../../utils/hostActions'
import { getRenewAction } from '../utils/renewActions'
import { getAutoRenewAction } from '../utils/autoRenewActions'
import { getDeleteAction } from '../utils/deleteActions'
// import { Base64 } from 'js-base64'
export default {
  computed: {
    ...mapGetters(['isAdminMode', 'isDomainMode', 'userInfo', 'auth', 'common']),
    enableMFA () {
      return this.userInfo.enable_mfa && this.auth.auth.system_totp_on
    },
    enableWaterMark () {
      const { globalConfig = {} } = this.common
      const { enable_watermark = true } = globalConfig
      return enable_watermark
    },
  },
  destroyed () {
    this.webconsoleManager = null
  },
  created () {
    this.webconsoleManager = new this.$Manager('webconsole', 'v1')

    this.singleActions = [
      {
        label: i18n.t('compute.text_341'),
        permission: 'server_get_vnc',
        actions: obj => {
          let ret = []
          if (this.isAdminMode) {
            ret.push(solWebConsole(this.webconsoleManager, obj, this.openWebConsole, this.createDialog))
          }
          const openWebConsole = async (params) => {
            let reqParams = params
            if (!params.data?.port) {
              const port = await getServerSshPort(new this.$Manager('servers'), params.action, 22)
              if (port) {
                reqParams = { ...params, data: { ...params.data, port } }
              }
            }
            this.webconsoleManager.performAction(reqParams).then(({ data }) => {
              const connectParams = qs.parse(data.connect_params)
              // 验证账号密码
              if (connectParams.is_need_login === 'true') {
                this.createDialog('SshAuthDialog', {
                  manager: this.webconsoleManager,
                  params: reqParams,
                  errorMsg: connectParams.login_error_message,
                  data: { name: obj.name, ip: params.data?.ip, id: obj.id, resource: 'servers' },
                  success: (data) => {
                    this.openWebConsole(obj, data, 'ws')
                  },
                })
                return
              }
              // 无需验证账号密码
              this.openWebConsole(obj, data, 'ws')
            })
          }
          const mapIpActions = (ipArr, type) => {
            if (!['IP SSH', 'EIP SSH'].includes(type)) throw Error(i18n.t('compute.text_343'))
            const options = []
            ipArr.forEach(v => {
              const meta = () => {
                const ret = {
                  validate: true,
                  tooltip: null,
                }
                if (obj.os_type === 'Windows') {
                  ret.tooltip = i18n.t('compute.text_344')
                  ret.validate = false
                  return ret
                }
                if (obj.provider === 'OneCloud') {
                  ret.validate = obj.power_states === 'on'
                  ret.tooltip = obj.power_states === 'on' ? '' : i18n.t('compute.power_states_check_tip', [i18n.t('compute.text_92'), `【${i18n.t('compute.text_574')}】`])
                } else {
                  ret.validate = obj.power_states === 'unknown' ? cloudEnabled(type, obj) : obj.power_states === 'on'
                  ret.tooltip = obj.power_states === 'unknown' ? cloudUnabledTip(type, obj) : (obj.power_states === 'on' ? '' : i18n.t('compute.power_states_check_tip', [i18n.t('compute.text_92'), `【${i18n.t('compute.text_574')}】`]))
                  if (cloudEnabled(type, obj) === false) {
                    ret.validate = false
                    ret.tooltip = cloudUnabledTip(type, obj)
                  }
                }
                return ret
              }
              // 与虚拟机一致：webconsole ssh 的 action 使用实例 id，ip 放在 data 中
              const buildSshParams = (extra = {}) => ({
                id: 'ssh',
                action: obj.id,
                data: {
                  id: obj.id,
                  ip: v,
                  type: 'server',
                  ...extra,
                },
              })
              options.push({
                label: `SSH ${v}`,
                action: () => {
                  const success = () => {
                    openWebConsole(buildSshParams())
                  }
                  if (this.enableMFA) {
                    this.createDialog('SecretVertifyDialog', {
                      success,
                    })
                  } else {
                    success()
                  }
                },
                meta,
                render: (obj, params, h) => {
                  let styleObj = {
                    padding: '0 10px',
                    fontSize: '12px',
                  }
                  const isRunning = obj.power_states === 'on'
                  if (!isRunning) {
                    styleObj = {
                      ...styleObj,
                      cursor: 'not-allowed',
                      color: 'rgba(0, 0, 0, 0.25)',
                    }
                  }
                  const sshConnectHandle = () => {
                    const success = () => {
                      openWebConsole(buildSshParams())
                    }
                    if (this.enableMFA) {
                      this.createDialog('SecretVertifyDialog', {
                        success,
                      })
                    } else {
                      success()
                    }
                  }
                  const sshSettingInfoHandle = () => {
                    this.createDialog('SmartFormDialog', {
                      title: i18n.t('compute.custom_ssh_connect', ['SSH']),
                      data: [obj],
                      callback: async (data) => {
                        openWebConsole(buildSshParams({
                          port: data.port,
                          username: data.username,
                          password: data.password,
                        }))
                      },
                      decorators: SMART_SSH_FORM_DECORATORS,
                    })
                  }
                  return <a-tooltip placement="left" title={!isRunning ? meta().tooltip : ''}>
                    <span style={styleObj} class='d-flex justify-content-between align-items-center'>
                      <span onClick={isRunning ? sshConnectHandle : () => { }}>{`SSH ${v}`}</span>
                      {
                        isRunning ? <span>
                          <a-tooltip title={i18n.t('compute.custom_ssh_connect', ['SSH'])}>
                            <a-icon class="ml-2" type="edit" onClick={isRunning ? sshSettingInfoHandle : () => { }} />
                          </a-tooltip>
                        </span> : null
                      }
                    </span>
                  </a-tooltip>
                },
              })
            })
            return options
          }
          let eips = (obj.eip || '').split(',').filter(item => !!item)
          let ips = (obj.ips || '').split(',').filter(item => !!item)
          eips = eips.length ? mapIpActions(eips, 'EIP SSH') : []
          ips = ips.length ? mapIpActions(ips, 'IP SSH') : []
          ret = ret.concat(eips).concat(ips)
          if (this.isAdminMode) {
            ret.push({ ...jnlpConsole(new this.$Manager('servers', 'v2'), obj, this.createDialog), permission: 'server_get_jnlp' })
          }
          return ret
        },
        meta: (obj) => {
          let ret = {
            validate: true,
            tooltip: null,
          }
          ret = this.$isValidateResourceLock(obj)
          return ret
        },
        hidden: () => this.$isScopedPolicyMenuHidden('baremetal_hidden_menus.server_web_console'),
      },
      {
        label: i18n.t('compute.text_352'),
        actions: (obj) => {
          return [
            {
              label: i18n.t('compute.text_353'),
              submenus: hostServerActions(this.onManager, obj, this, false),
            },
            {
              label: i18n.t('compute.text_356'),
              submenus: [
                {
                  label: i18n.t('compute.text_357'),
                  permission: 'server_perform_rebuild_root',
                  action: () => {
                    this.createDialog('VmRebuildRootDialog', {
                      data: [obj],
                      columns: this.columns,
                      onManager: this.onManager,
                    })
                  },
                  meta: () => {
                    const ret = {
                      validate: true,
                      tooltip: null,
                    }
                    if (obj.metadata.is_fake_baremetal_server === 'true') {
                      ret.tooltip = i18n.t('compute.tooltip.check_fake_baremetal_server')
                      ret.validate = false
                      return ret
                    }
                    if (obj.status !== 'ready' && obj.status !== 'admin') {
                      ret.tooltip = i18n.t('compute.text_358')
                      ret.validate = false
                      return ret
                    }
                    if (commonUnabled(obj)) return ret
                    ret.validate = cloudEnabled('rebuildRoot', { ...obj, brand: 'baremetal' })
                    ret.tooltip = cloudUnabledTip('rebuildRoot', { ...obj, brand: 'baremetal' })
                    return ret
                  },
                  hidden: () => this.$isScopedPolicyMenuHidden('baremetal_hidden_menus.server_perform_rebuild_root'),
                },
                {
                  label: i18n.t('compute.perform_sync_status'),
                  permission: 'server_perform_syncstatus',
                  action: () => {
                    this.onManager('performAction', {
                      steadyStatus: Object.values(expectStatus.server).flat(),
                      id: obj.id,
                      managerArgs: {
                        action: 'syncstatus',
                      },
                    })
                  },
                  hidden: () => this.$isScopedPolicyMenuHidden('baremetal_hidden_menus.server_perform_syncstatus'),
                },
                {
                  label: this.$t('compute.perform_change_owner', [this.$t('dictionary.project')]),
                  permission: 'server_perform_change_owner',
                  action: () => {
                    this.createDialog('ChangeOwenrDialog', {
                      data: [obj],
                      columns: this.columns,
                      onManager: this.onManager,
                      resource: 'servers',
                    })
                  },
                  meta: () => {
                    const ret = {
                      validate: false,
                      tooltip: null,
                    }
                    if (commonUnabled(obj)) return ret
                    ret.validate = true
                    return ret
                  },
                  hidden: () => this.$isScopedPolicyMenuHidden('baremetal_hidden_menus.server_perform_change_owner'),
                },
                {
                  label: i18n.t('compute.text_359'),
                  permission: 'server_create',
                  action: () => {
                    this.createDialog('VmCloneDialog', {
                      data: [obj],
                      columns: this.columns,
                      onManager: this.onManager,
                      type: 'baremetal',
                    })
                  },
                  meta: () => {
                    const ret = {
                      validate: true,
                      tooltip: null,
                    }
                    if (obj.metadata.is_fake_baremetal_server === 'true') {
                      ret.tooltip = i18n.t('compute.tooltip.check_fake_baremetal_server')
                      ret.validate = false
                      return ret
                    }
                    return ret
                  },
                  hidden: () => this.$isScopedPolicyMenuHidden('baremetal_hidden_menus.server_perform_create_same_config'),
                },
                // 续费
                getRenewAction(this, obj),
                // 自动续费设置
                getAutoRenewAction(this, obj),
              ],
            },
            {
              label: i18n.t('compute.text_360'),
              submenus: [
                {
                  label: i18n.t('compute.text_276'),
                  permission: 'server_perform_deploy',
                  action: () => {
                    this.createDialog('VmResetPasswordDialog', {
                      data: [obj],
                      columns: this.columns,
                      onManager: this.onManager,
                    })
                  },
                  meta: () => {
                    const ret = {
                      validate: true,
                      tooltip: null,
                    }
                    if (obj.metadata.is_fake_baremetal_server === 'true') {
                      ret.tooltip = i18n.t('compute.tooltip.check_fake_baremetal_server')
                      ret.validate = false
                      return ret
                    }
                    if (obj.keypair_id && obj.keypair_id.toLowerCase() !== 'none') {
                      ret.tooltip = i18n.t('compute.text_277')
                      ret.validate = false
                      return ret
                    }
                    if (commonUnabled(obj)) return ret
                    ret.validate = cloudEnabled('resetPassword', { ...obj, brand: 'baremetal' })
                    ret.tooltip = cloudUnabledTip('resetPassword', { ...obj, brand: 'baremetal' })
                    return ret
                  },
                  hidden: () => this.$isScopedPolicyMenuHidden('baremetal_hidden_menus.server_perform_reset_password'),
                },
                {
                  label: i18n.t('compute.text_361'),
                  permission: 'server_perform_deploy',
                  action: () => {
                    this.createDialog('VmBindKeypairDialog', {
                      data: [obj],
                      columns: this.columns,
                      onManager: this.onManager,
                    })
                  },
                  meta: () => {
                    const ret = {
                      validate: true,
                      tooltip: null,
                    }
                    if (obj.metadata.is_fake_baremetal_server === 'true') {
                      ret.tooltip = i18n.t('compute.tooltip.check_fake_baremetal_server')
                      ret.validate = false
                      return ret
                    }
                    if (obj.os_type === 'Windows') {
                      ret.tooltip = i18n.t('compute.text_362')
                      ret.validate = false
                      return ret
                    }
                    if (obj.keypair) {
                      ret.tooltip = i18n.t('compute.text_363')
                      ret.validate = false
                      return ret
                    }
                    if (commonUnabled(obj)) return ret
                    ret.validate = cloudEnabled('bindKeyPair', obj)
                    ret.tooltip = cloudUnabledTip('bindKeyPair', obj)
                    return ret
                  },
                  hidden: () => this.$isScopedPolicyMenuHidden('baremetal_hidden_menus.server_perform_bind_key'),
                },
                {
                  label: i18n.t('compute.text_364'),
                  permission: 'server_perform_deploy',
                  action: () => {
                    this.createDialog('VmUnbindKeypairDialog', {
                      data: [obj],
                      columns: this.columns,
                      onManager: this.onManager,
                    })
                  },
                  meta: () => {
                    const ret = {
                      validate: true,
                      tooltip: null,
                    }
                    if (obj.metadata.is_fake_baremetal_server === 'true') {
                      ret.tooltip = i18n.t('compute.tooltip.check_fake_baremetal_server')
                      ret.validate = false
                      return ret
                    }
                    if (obj.os_type === 'Windows') {
                      ret.tooltip = i18n.t('compute.text_362')
                      ret.validate = false
                      return ret
                    }
                    if (!obj.keypair) {
                      ret.tooltip = i18n.t('compute.text_365')
                      ret.validate = false
                      return ret
                    }
                    if (commonUnabled(obj)) return ret
                    ret.validate = cloudEnabled('unBindKeyPair', obj)
                    ret.tooltip = cloudUnabledTip('unBindKeyPair', obj)
                    return ret
                  },
                  hidden: () => this.$isScopedPolicyMenuHidden('baremetal_hidden_menus.server_perform_unbind_key'),
                },
                // 设置免密登录
                {
                  label: i18n.t('compute.vminstance.actions.setup_ssh_authentication'),
                  permission: 'server_perform_setup_ssh_proxy',
                  action: () => {
                    this.createDialog('SetupSSHDialog', {
                      data: [obj],
                      columns: this.columns,
                      onManager: this.onManager,
                    })
                  },
                  meta: () => {
                    const ret = {
                      validate: true,
                      tooltip: null,
                    }
                    if (obj.hypervisor === typeClouds.hypervisorMap.sangfor.key) {
                      ret.validate = false
                      ret.tooltip = i18n.t('compute.text_473', [typeClouds.hypervisorMap.sangfor.label])
                      return ret
                    }
                    const rescueModeValid = validateRescueMode(obj)
                    if (!rescueModeValid.validate) return rescueModeValid
                    const isLinux = obj.os_type && obj.os_type.toLowerCase() === 'linux'
                    if (!isLinux) {
                      ret.validate = false
                      ret.tooltip = i18n.t('compute.text_362')
                      return ret
                    }
                    if (!commonEnabled(obj, ['running'])) {
                      ret.validate = false
                      ret.tooltip = i18n.t('db.text_156')
                      return ret
                    }
                    return ret
                  },
                  hidden: () => this.$isScopedPolicyMenuHidden('baremetal_hidden_menus.server_perform_setup_ssh_proxy'),
                },
                // 探测免密登录
                {
                  label: i18n.t('compute.vminstance.actions.detect_ssh_authentication'),
                  permission: 'server_perform_make_sshable',
                  action: () => {
                    this.createDialog('DetectSSHDialog', {
                      data: [obj],
                      columns: this.columns,
                      onManager: this.onManager,
                    })
                  },
                  meta: () => {
                    const ret = {
                      validate: true,
                      tooltip: null,
                    }
                    if (obj.hypervisor === typeClouds.hypervisorMap.sangfor.key) {
                      ret.validate = false
                      ret.tooltip = i18n.t('compute.text_473', [typeClouds.hypervisorMap.sangfor.label])
                      return ret
                    }
                    const rescueModeValid = validateRescueMode(obj)
                    if (!rescueModeValid.validate) return rescueModeValid
                    if (!commonEnabled(obj, ['running'])) {
                      ret.validate = false
                      ret.tooltip = i18n.t('db.text_156')
                      return ret
                    }
                    return ret
                  },
                  hidden: () => this.$isScopedPolicyMenuHidden('baremetal_hidden_menus.server_perform_detect_ssh_proxy'),
                },
              ],
            },
            {
              label: i18n.t('compute.text_96'),
              submenus: [
                {
                  label: i18n.t('compute.text_366'),
                  permission: 'server_perform_set_iso',
                  action: () => {
                    this.createDialog('VmMountIsoDialog', {
                      data: [obj],
                      columns: this.columns,
                      onManager: this.onManager,
                      refresh: this.refresh,
                    })
                  },
                  meta: () => {
                    return {
                      validate: !!obj.cdrom_support,
                    }
                  },
                  hidden: () => this.$isScopedPolicyMenuHidden('baremetal_hidden_menus.server_perform_mount_iso'),
                },
              ],
            },
            {
              label: i18n.t('compute.perform_delete'),
              submenus: [
                disableDeleteAction(this, {
                  hidden: () => this.$isScopedPolicyMenuHidden('baremetal_hidden_menus.server_set_delete_protection'),
                }),
                // 删除（GPU scope 可自定义，默认 DeleteResDialog）
                getDeleteAction(this, obj),
              ],
            },
          ]
        },
        meta: (obj) => {
          let ret = {
            validate: true,
            tooltip: null,
          }
          ret = this.$isValidateResourceLock(obj)
          return ret
        },
      },
    ]
  },
  methods: {
    openWebConsole (obj, data, protocol) {
      this.$openWebConsole(data)
    },
  },
}
